import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import './styles/Styles.css'
import style from './styles/aboutme.module.css'

import figureHumanoid from './aboutme/figure/figure-3-humanoid-inc.webp'
import figureHands from './aboutme/figure/07tGpPe3i4F68L0tyXv3myR-1.fit_lim.v1760032080.png'
import humaneHero from './aboutme/aipin/hero-image.webp'
import humaneBusiness from './aboutme/aipin/Humane-Ai-Pin-Business.webp'
import nexusDesign from './aboutme/cornell-nexus/nexus-design.png'
import nexusTeam from './aboutme/cornell-nexus/team.jpg'
import eggschangeJpg from './aboutme/eggschange/643952616_26511148778489828_8323879253633527544_n.jpg'
import eggschangeAvif from './aboutme/eggschange/88e104_a6943a6d4a75497686b2758331e31d80.avif'
import panCubeSat from './aboutme/cornell-pan/cube-sat.jpeg'
import panPhoto from './aboutme/cornell-pan/1711343033964.jpg'

const figurePhotos = [
  { src: figureHumanoid, alt: 'Figure humanoid robot' },
  { src: figureHands, alt: 'Figure robotic hands' },
]

const humanePhotos = [
  { src: humaneHero, alt: 'Humane Ai Pin' },
  { src: humaneBusiness, alt: 'Humane Ai Pin business' },
]

const nexusPhotos = [
  { src: nexusDesign, alt: 'Cornell Nexus design', zoomCrop: true },
  { src: nexusTeam, alt: 'Cornell Nexus team' },
]

const eggschangePhotos = [
  { src: eggschangeJpg, alt: 'Eggschange' },
  { src: eggschangeAvif, alt: 'Eggschange project' },
]

const panPhotos = [
  { src: panPhoto, alt: 'PAN project' },
  { src: panCubeSat, alt: 'PAN cube satellite' },
]

const AboutMe = () => {
    return (
        <section className="ideas">
            <Navbar />
            <div className={style.PagePadding}>
                <div className={style.aboutMainColumn}>
                    <div className={`cards title ${style.aboutPageTitle}`}>
                        <h1>About Me</h1>
                        <br />
                    </div>

                    <div className={style.Writing}>
                    <div className={style.introBlock}>
                    <p className={style.introLead}>Hi there!</p>
                    <p>
                        I&apos;m a hardware engineer who wants to make tinkering on fun projects accessible to all.
                    </p>
                    <p>
                        I have a curiosity for making the world a better place, and I&apos;m always looking for new ways to do so.
                        I love learning about how things work. 
                        
                        <br></br><br></br>
                        Today, I&apos;m currently building my own company,{" "}
                        <a
                            href="https://tinkio.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.Link}
                        >
                            Tinkio
                        </a>
                        . Below are some of the teams & past projects I&apos;ve been lucky to be a part of.
                    </p>
                    <p className={style.introBeforeGallery}>
                        Always excited about meeting new people! Feel free to reach out to me via{" "}
                        <a href="mailto:angelaloh09@gmail.com" className={style.Link}>
                            email
                        </a>
                        {" "}
                        or{" "}
                        <a
                            href="https://www.linkedin.com/in/angelalohh/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.Link}
                        >
                            linkedin
                        </a>
                        .
                    </p>
                    </div>

                    <section className={style.mediaGallery} aria-label="Work photos">
                        <div className={style.mediaCompanyBlock}>
                            <div className={style.mediaCompanyText}>
                                <h3 className={style.mediaHeading}>Figure Ai</h3>
                                <p className={style.mediaCaption}> Figure AI builds advanced humanoid robots to take on dangerous and undesirable tasks.
                                    <br></br> <br></br>
                                    I was one of two electrical engineers who designed, built, and tested all of the electronics for the Figure 3 & 4&nbsp;
                                    <a
                                        href="https://www.youtube.com/watch?v=IlG3X8zRI2I&t=9"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={style.Link}
                                    >
                                        robotic hands
                                    </a>
                                    .
                                </p>
                            </div>
                            <div className={style.mediaRow}>
                                {figurePhotos.map(({ src, alt }, i) => (
                                    <img
                                        key={`figure-${i}`}
                                        src={src}
                                        alt={alt}
                                        className={style.mediaImage}
                                        loading="eager"
                                        decoding="async"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className={style.mediaCompanyBlock}>
                            <div className={style.mediaCompanyText}>
                                <h3 className={style.mediaHeading}>Humane Ai Pin</h3>
                                <p className={style.mediaCaption}>
                                The Ai Pin is a wearable computer that acts as an intelligent assistant and helps people engage with the world without a screen.
                                    <br></br><br></br>
                                    I helped design & ship the&nbsp;
                                    <a
                                        href="https://www.youtube.com/watch?v=9lNIwOOMVHk&t=177s"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={style.Link}
                                    >
                                        laser display
                                    </a>
                                    &nbsp;that projects the interface onto the user's hand. 
                                </p>
                            </div>
                            <div className={style.mediaRow}>
                                {humanePhotos.map(({ src, alt }, i) => (
                                    <img
                                        key={`humane-${i}`}
                                        src={src}
                                        alt={alt}
                                        className={style.mediaImage}
                                        loading="eager"
                                        decoding="async"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className={style.mediaCompanyBlock}>
                            <div className={style.mediaCompanyText}>
                                <h3 className={style.mediaHeading}>Cornell Nexus</h3>
                                <p className={style.mediaCaption}>
                                    I co-founded a 30+ student team to build an{" "}
                                    <a
                                        href="https://news.cornell.edu/stories/2022/12/students-design-robot-collect-microplastics-beaches"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={style.Link}
                                    >
                                        autonomous "beach roomba"
                                    </a>
                                    {" "}
                                    that filters out macro+micro-plastics from sand at Cornell. 

                                    <br></br> 
                                    <br></br>
                                    I've always deeply cared about the environment. This was my way of making a tangible impact during my time throughout university.
                                </p>
                            </div>
                            <div className={style.mediaRow}>
                                {nexusPhotos.map(({ src, alt, zoomCrop }, i) =>
                                    zoomCrop ? (
                                        <div key={`nexus-${i}`} className={style.mediaImageCrop}>
                                            <img
                                                src={src}
                                                alt={alt}
                                                className={style.mediaImageZoomNexus}
                                                loading="eager"
                                                decoding="async"
                                            />
                                        </div>
                                    ) : (
                                        <img
                                            key={`nexus-${i}`}
                                            src={src}
                                            alt={alt}
                                            className={style.mediaImage}
                                            loading="eager"
                                            decoding="async"
                                        />
                                    )
                                )}
                            </div>
                        </div>
                        <div className={style.mediaCompanyBlock}>
                            <div className={style.mediaCompanyText}>
                                <h3 className={style.mediaHeading}>Space Systems Design Studio</h3>
                                <p className={style.mediaCaption}>
                                    Shipped{" "}
                                    <a
                                        href="https://www.spacecraftresearch.com/pan"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={style.Link}
                                    >
                                        two cube satellites
                                    </a>
                                    {" "}
                                    to space with Cornell's Space Systems Design Studio (Pathfinder Autonomous Navigation team).
                                    <br></br>
                                    <br></br>
                                    We were selected to launch with NASA&apos;s CubeSat Launch Initiative.&nbsp;
                                    <a
                                        href="https://www.nasa.gov/blogs/smallsatellites/2022/01/13/nasa-satellites-launch-aboard-virgin-orbits-launcherone/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={style.Link}
                                    >
                                        NASA article
                                    </a>
                                    &nbsp;on us!
                                </p>
                            </div>
                            <div className={style.mediaRow}>
                                {panPhotos.map(({ src, alt }, i) => (
                                    <img
                                        key={`pan-${i}`}
                                        src={src}
                                        alt={alt}
                                        className={style.mediaImage}
                                        loading="eager"
                                        decoding="async"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className={style.mediaCompanyBlock}>
                            <div className={style.mediaCompanyText}>
                                <h3 className={style.mediaHeading}>The Eggschange Project</h3>
                                <p className={style.mediaCaption}>
                                Eggschange is a microfinance initiative partnering with rural farmers in China, selling their eggs to our school community and returning proceeds to support their income and children’s education.
                                <br></br><br></br>
                                I dedicated all of my high school years to this project, serving as President for the final two.
                                </p>
                            </div>
                            <div className={style.mediaRow}>
                                {eggschangePhotos.map(({ src, alt }, i) => (
                                    <img
                                        key={`eggschange-${i}`}
                                        src={src}
                                        alt={alt}
                                        className={style.mediaImage}
                                        loading="eager"
                                        decoding="async"
                                    />
                                ))}
                            </div>
                        </div>
                    </section>

                    <p className={style.afterGalleryParagraph}>
                        If you're curious... more of my hobbyist/personal projects can be found&nbsp;
                        <Link to="/projects" className={style.Link}>here :)</Link>
                    </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutMe
